import { render, staticRenderFns } from "./AttachmentsPanel.vue?vue&type=template&id=2a1907f1&"
import script from "./AttachmentsPanel.vue?vue&type=script&lang=js&"
export * from "./AttachmentsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports